const flowMonitorKeys = {
  PERCENTILE_TRACKER: "percentile-tracker",
  GROWTH_GAUGE: "growth-gauge",
  COMPETITIVE_POSITIONING: "competitive-positioning",
  ASSET_MOMENTUM: "asset-momentum",
  ASSET_MIX: "asset-mix",
  LEADERS_LAGGARDS: "leaders-laggards",
}

const flowMonitorParameters = {
  DISABLED_ENTITY_REF_ID: "MSTAR:0000000000",
  DISABLED_COMPARISON_REF_ID: "None",
  VAL_GROWTH_TYPE_ID: "Absolute",
}

export { flowMonitorKeys, flowMonitorParameters }
